// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  	production: false,
};

// export const BASE_URL = 'https://dev-dubravica.dream-impl.com/dubravica_api/v1.0/';
// export const UPLOAD_URL = 'https://dev-dubravica.dream-impl.com/upload/';

export const BASE_URL = 'https://mobile-app.pekara-dubravica.hr/dubravica_api/v1.0/';
export const UPLOAD_URL = 'https://mobile-app.pekara-dubravica.hr/upload/';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/environments/environment.ts